import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=2238bca0&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=2238bca0&prod&lang=less"
import style1 from "./OrderManagement.vue?vue&type=style&index=1&id=2238bca0&prod&lang=less&scoped=true"
import style2 from "./OrderManagement.vue?vue&type=style&index=2&id=2238bca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238bca0",
  null
  
)

export default component.exports